import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from './UserContext';

const defaultPathByRole = {
  warehouse: '/bookings',
  accounts: '/',
  front_office: '/products',
  admin: '/',
};

const ProtectedRoute = ({ component: Component, allowedRoles, ...rest }) => {
  const { user } = useUser();
  const role = (user?.role || '').toLowerCase();
  const allowed = (allowedRoles || []).map((r) => String(r).toLowerCase());
  if (user && allowed.includes(role)) {
    return <Component {...rest} />;
  }
  if (user) {
    const fallback = defaultPathByRole[role] || '/bookings';
    return <Navigate to={fallback} replace />;
  }
  return <Navigate to="/login" replace />;
};

export default ProtectedRoute; 
